import { createContext } from "react";

export interface IDirtyPageContext
{
    readonly isAnyPageDirty: boolean;
    setPageDirty: (pageKey: string, isDirty: boolean) => void;
}

export const DirtyPageContext = createContext<IDirtyPageContext | undefined>(
    undefined,
);
